// The API serialises enums as integers, so the UI speaks the same numbers.
// Keep these in sync with Domain/Models/Enums/BackupEnums.cs.

export const BACKUP_TYPE = { MANUAL: 0, SCHEDULED: 1, SAFETY: 2 };

export const BACKUP_TYPE_LABEL = {
  [BACKUP_TYPE.MANUAL]: "Manual",
  [BACKUP_TYPE.SCHEDULED]: "Scheduled",
  [BACKUP_TYPE.SAFETY]: "Safety",
};

export const BACKUP_TYPE_COLOR = {
  [BACKUP_TYPE.MANUAL]: "blue",
  [BACKUP_TYPE.SCHEDULED]: "geekblue",
  [BACKUP_TYPE.SAFETY]: "gold",
};

export const BACKUP_STATUS = { RUNNING: 0, COMPLETED: 1, FAILED: 2 };

export const BACKUP_STATUS_LABEL = {
  [BACKUP_STATUS.RUNNING]: "Running",
  [BACKUP_STATUS.COMPLETED]: "Completed",
  [BACKUP_STATUS.FAILED]: "Failed",
};

export const BACKUP_STATUS_COLOR = {
  [BACKUP_STATUS.RUNNING]: "processing",
  [BACKUP_STATUS.COMPLETED]: "success",
  [BACKUP_STATUS.FAILED]: "error",
};

export const RESTORE_MODE = { FULL: 0, SELECTIVE: 1 };

export const RESTORE_STRATEGY = { UPSERT: 0, INSERT_MISSING: 1, REPLACE: 2 };

export const STRATEGY_HELP = {
  [RESTORE_STRATEGY.UPSERT]:
    "Rows that already exist are updated with the source values; rows that are missing are inserted.",
  [RESTORE_STRATEGY.INSERT_MISSING]:
    "Existing rows are left exactly as they are. Only rows whose key is not present get inserted.",
  [RESTORE_STRATEGY.REPLACE]:
    "Every selected table is emptied first, then refilled from the source. Anything not in the source is lost.",
};

export const DB_ENGINE = { SQL_SERVER: 0, POSTGRES: 1, MYSQL: 2 };

export const ENGINE_OPTIONS = [
  { value: DB_ENGINE.SQL_SERVER, label: "SQL Server", defaultPort: 1433 },
  { value: DB_ENGINE.POSTGRES, label: "PostgreSQL", defaultPort: 5432 },
  { value: DB_ENGINE.MYSQL, label: "MySQL / MariaDB", defaultPort: 3306 },
];

// Keep in sync with Domain/Models/Enums/FtpEnums.cs.
export const FTP_PROTOCOL = { FTP: 0, FTPS_EXPLICIT: 1, FTPS_IMPLICIT: 2 };

export const FTP_PROTOCOL_OPTIONS = [
  { value: FTP_PROTOCOL.FTP, label: "FTP (plain)", defaultPort: 21 },
  { value: FTP_PROTOCOL.FTPS_EXPLICIT, label: "FTPS — explicit TLS", defaultPort: 21 },
  { value: FTP_PROTOCOL.FTPS_IMPLICIT, label: "FTPS — implicit TLS", defaultPort: 990 },
];

export const FTP_PROTOCOL_LABEL = {
  [FTP_PROTOCOL.FTP]: "FTP",
  [FTP_PROTOCOL.FTPS_EXPLICIT]: "FTPS explicit",
  [FTP_PROTOCOL.FTPS_IMPLICIT]: "FTPS implicit",
};

export const FTP_UPLOAD_STATUS = { PENDING: 0, UPLOADED: 1, FAILED: 2 };

export const FTP_UPLOAD_STATUS_LABEL = {
  [FTP_UPLOAD_STATUS.PENDING]: "Uploading",
  [FTP_UPLOAD_STATUS.UPLOADED]: "On FTP",
  [FTP_UPLOAD_STATUS.FAILED]: "FTP failed",
};

export const FTP_UPLOAD_STATUS_COLOR = {
  [FTP_UPLOAD_STATUS.PENDING]: "processing",
  [FTP_UPLOAD_STATUS.UPLOADED]: "success",
  [FTP_UPLOAD_STATUS.FAILED]: "error",
};

// Keep in sync with Domain/Models/Enums/StorageEnums.cs.
export const STORAGE_UPLOAD_STATUS = { PENDING: 0, UPLOADED: 1, FAILED: 2 };

export const STORAGE_UPLOAD_STATUS_LABEL = {
  [STORAGE_UPLOAD_STATUS.PENDING]: "Uploading",
  [STORAGE_UPLOAD_STATUS.UPLOADED]: "In S3",
  [STORAGE_UPLOAD_STATUS.FAILED]: "S3 failed",
};

export const STORAGE_UPLOAD_STATUS_COLOR = {
  [STORAGE_UPLOAD_STATUS.PENDING]: "processing",
  [STORAGE_UPLOAD_STATUS.UPLOADED]: "success",
  [STORAGE_UPLOAD_STATUS.FAILED]: "error",
};

// Which off-site target the "Backup files" tab is reading. Keep in sync with
// Domain/Models/Enums/BackupEnums.cs.
export const BACKUP_PROVIDER = { FTP: 0, S3: 1 };

export const BACKUP_PROVIDER_LABEL = {
  [BACKUP_PROVIDER.FTP]: "FTP",
  [BACKUP_PROVIDER.S3]: "S3 storage",
};

export const BACKUP_PROVIDER_OPTIONS = [
  { value: BACKUP_PROVIDER.FTP, label: BACKUP_PROVIDER_LABEL[BACKUP_PROVIDER.FTP] },
  { value: BACKUP_PROVIDER.S3, label: BACKUP_PROVIDER_LABEL[BACKUP_PROVIDER.S3] },
];

export const BACKUPS_ENDPOINT = "/v1/admin/backups";

export const FTP_ENDPOINT = "/v1/admin/ftp-connections";

export const STORAGE_ENDPOINT = "/v1/admin/storage";

export const formatBytes = (bytes) => {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / 1024 ** exponent).toFixed(exponent === 0 ? 0 : 1)} ${units[exponent]}`;
};

export const formatDuration = (ms) => {
  if (!ms) return "—";
  if (ms < 1000) return `${ms} ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)} s`;
  return `${Math.floor(ms / 60000)}m ${Math.round((ms % 60000) / 1000)}s`;
};
